/**
 * Product methods
 * -----------------------------------------------------------------------------
 *
 * @namespace product
 */

import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fullscreen';
import zoomio from 'zoomio';
import enquire from 'enquire.js';
import * as filestack from 'filestack-js';

// import detectIt from 'detect-it';
import scrollMonitor from 'scrollmonitor';

var productMethods = {
  data: function data() {
    return {
      enableHistoryState: false,
      isProductToolbarMobileOpen: false,
      product: {},
      currentVariant: {},
      mainProduct: {},
      allCustomImages: [],
      itemID: ''
    };
  },


  methods: {

    /**
     * Product Single
     */
    _initProduct: function _initProduct() {
      var $container = $('[data-template="product"]');
      var $productTabs = $(app.selectors.productTabs);
      var $productToolbarMobile = $(app.selectors.productToolbarMobile);
      var $imageZoom = $(app.selectors.imageZoom);
      var productObj = app.selectors.productObj;

      // product tabs add active class to 1st child
      $productTabs.find('.nav-item').first().find('a').addClass('active');
      $productTabs.find('.tab-content .tab-pane').first().addClass('active');

      // stop parsing if we are not in the product template
      if (app.currentTemplate !== 'product') {
        return;
      }

      // Cookies
      var today = new Date();
      var expirationDate = new Date();
      expirationDate.setDate(today.getDate());
      var time = expirationDate.getTime();
      var expireTime = time + 1000 * 36000;
      expirationDate.setTime(expireTime);

      // set data
      app.product = JSON.parse($(productObj).html());
      var productData = JSON.parse($(productObj).html());
      app.product = productData.product;
      app.product.options_with_values = productData.options_with_values;

      // eslint-disable-next-line eqeqeq
      if (app._getCookie('mainMaterial') != 'mainMaterial' && $('[data-simple-product]').length == 0) {
        // OTHER PRODUCT SEARCH
        var isCheckProductID = app._getCookie('productID');
        var isCheckMcat = app._getCookie('mcat');
        var currentUrl = app._getCookie('current_url');
        var handleAdded = void 0;

        // eslint-disable-next-line eqeqeq
        if (isCheckProductID != '' && isCheckMcat != '') {
          // eslint-disable-next-line eqeqeq
          if (currentUrl.indexOf('-floor-mats') == -1 && app._getCookie('mainMaterial').indexOf('floor-mats') == -1 && app.product.handle.indexOf('-floor-mats') > -1 && (isCheckProductID != 'DFM' || isCheckProductID != 'CCL')) {
            isCheckProductID = 'DFM';
            handleAdded = 'floor-mats-' + app._handleize(app.product.variants[0].title);
            // eslint-disable-next-line eqeqeq
          } else if (currentUrl.indexOf('-seat-cover') == -1 && app._getCookie('mainMaterial').indexOf('seat-cover') == -1 && app.product.handle.indexOf('-seat-cover') > -1 && (isCheckProductID != 'CSC' || isCheckProductID != 'MSC' || isCheckProductID != 'CTSC')) {
            isCheckProductID = 'CSC';
            handleAdded = 'seat-cover-' + app._handleize(app.product.variants[25].title);
            // eslint-disable-next-line eqeqeq
          } else if (currentUrl.indexOf('-car-cover') == -1 && app._getCookie('mainMaterial').indexOf('car-cover') == -1 && app.product.handle.indexOf('-car-cover') > -1 && isCheckProductID != 'CVC') {
            isCheckProductID = 'CVC';
            handleAdded = 'car-cover-' + app._handleize(app.product.variants[0].title);
            // eslint-disable-next-line eqeqeq
          } else if (currentUrl.indexOf('-dash-cover') == -1 && app._getCookie('mainMaterial').indexOf('dash-cover') == -1 && app.product.handle.indexOf('-dash-cover') > -1 && (isCheckProductID != 'CDC' || isCheckProductID != 'MDC')) {
            isCheckProductID = 'CDC';
            if (app.product.variants[8]) {
              handleAdded = 'dash-cover-' + app._handleize(app.product.variants[8].title);
            } else {
              handleAdded = 'dash-cover-' + app._handleize(app.product.variants[0].title);
            }
            // eslint-disable-next-line eqeqeq
          } else if (currentUrl.indexOf('-rear-deck-cover') == -1 && app._getCookie('mainMaterial').indexOf('rear-deck-cover') == -1 && app.product.handle.indexOf('-rear-deck-cover') > -1 && isCheckProductID != 'CRD') {
            isCheckProductID = 'CRD';
            handleAdded = 'rear-deck-cover-' + app._handleize(app.product.variants[0].title);
            // eslint-disable-next-line eqeqeq
          } else if (currentUrl.indexOf('-frost-shield') == -1 && app._getCookie('mainMaterial').indexOf('frost-shield') == -1 && app.product.handle.indexOf('-frost-shield') > -1 && isCheckProductID != 'CFS') {
            isCheckProductID = 'CFS';
            handleAdded = 'frost-shield';
            // eslint-disable-next-line eqeqeq
          } else if (currentUrl.indexOf('-frost-shield') == -1 && app._getCookie('mainMaterial').indexOf('frost-shield') == -1 && app.product.handle.indexOf('-frost-shield') > -1 && isCheckProductID != 'CSS') {
            isCheckProductID = 'CSS';
            handleAdded = 'custom-sunshield';
          }

          // eslint-disable-next-line eqeqeq
          if (handleAdded != undefined) {
            axios.get('/products/' + handleAdded + '.json')
            // eslint-disable-next-line promise/always-return
            .then(function (response) {
              var arraTags = response.data.product.tags.split(',');
              arraTags.forEach(function (tag) {
                if (tag.indexOf('mcat') > -1) {
                  isCheckMcat = tag.replace('mcat-', '');
                }
                document.cookie = 'mainMaterial=' + handleAdded + ';expires=' + expirationDate.toGMTString() + ';path=/';
                document.cookie = 'productID=' + isCheckProductID + ';expires=' + expirationDate.toGMTString() + ';path=/';
                document.cookie = 'mcat=' + isCheckMcat + ';expires=' + expirationDate.toGMTString() + ';path=/';
              });
            }).catch(function (error) {
              console.log(error);
              throw error;
            });
          }
        }
        app._getAllDetails();
      }

      // assign the product cart limit
      app.product.tags.forEach(function (tag) {
        if (tag.match('cart-limit')) {
          var cartLimit = tag.replace('cart-limit-', '');
          app.product.cart_limit = parseFloat(cartLimit);
          // console.log(app.product);
        }
        if (tag.match('Universal_product')) {
          app.itemID = app.product.sku;
          // app._getOption('', '');
        }
        if (tag.indexOf('Custom ') > -1) {
          app._fileUpload(app._handleize(tag).replace('custom-'));
          app._getByHandle(app._handleize(tag).replace('custom-'));
        }
      });

      // eslint-disable-next-line eqeqeq
      if (app.product.type != '') {
        app._fileUpload(app._handleize(app.product.type));
        app._getByHandle(app._handleize(app.product.type));
      }

      app.enableHistoryState = $container.data('enable-history-state');
      app._getVariant();

      setTimeout(function () {
        // if ($('[data-color-swatch-group]').length > 0) {
        //   $('[data-color-swatch-group] .color-swatch:first label').trigger('click');
        // }
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var $target = $('[data-closest]');
        // eslint-disable-next-line eqeqeq - condition: $target.find('select option').length == 2
        // if ($target.length == 1) {
        if ($('[data-section-id="template-product-3"]').length == 0 && $target.find('select').val($target.find('select option').length == 2)) {
          $target.find('select').val($target.find('select option:last').attr('value')).trigger('change');
          app.selectedRecID = $target.find('select option:last').attr('value');
          app._getCartPrice($target);
          // eslint-disable-next-line eqeqeq
          // if ($('[data-color-swatch-group]').length == 1) {
          // }
          if ($target.length == 1) {
            $('[data-closest] h6').text('1. ' + $('[data-closest] h6').text().split('.')[1]);
          }
        }
        // }
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        // const $div = $('[data-check-select]:first');
        // // eslint-disable-next-line eqeqeq
        // if ($div.length == 1 && $div.find('select option').length == 2) {
        //   $div.find('select').val($div.find('select option:last').attr('value')).trigger('change');
        //   app.selectedRecID = $target.find('select option:last').attr('value');
        //   $div.closest('[data-seat-template]').attr('data-recID', $div.find('select option:last').attr('value'));
        // }
      }, 5000);

      // Auto selected
      if (window.location.href.indexOf('color=') > -1) {
        app._autoSelected(window.location.href.split('color=')[1]);
      }

      // Recharge widget
      app._attachRechargeWidget(app.product.id);

      if ($('[data-universal-seat-cover]').length > 0) {
        app._getUniversalSeatCover();
      }

      app.product.joinTags = app.product.tags.join();

      function registerMobileToolbar() {
        var productFormPosition = $(app.selectors.productForm).position();
        var formWatcher = scrollMonitor.create($(app.selectors.productForm));
        var footerWatcher = scrollMonitor.create($('[data-footer-bottom]'));
        $productToolbarMobile.show();

        window.addEventListener('scroll', function () {
          var windowScrollY = window.scrollY;

          if (windowScrollY > productFormPosition.top) {
            formWatcher.exitViewport(function () {
              // console.log( 'I have left the viewport' )
              $productToolbarMobile.addClass('semi-opened');
            });

            formWatcher.enterViewport(function () {
              // console.log( 'I have entered the viewport' )
              $productToolbarMobile.removeClass('semi-opened fully-opened');
              if (app.isProductToolbarMobileOpen) {
                app.isProductToolbarMobileOpen = false;
              }
            });

            footerWatcher.exitViewport(function () {
              $productToolbarMobile.addClass('semi-opened');
            });

            footerWatcher.enterViewport(function () {
              $productToolbarMobile.removeClass('semi-opened fully-opened');
              if (app.isProductToolbarMobileOpen) {
                app.isProductToolbarMobileOpen = false;
              }
            });
          } else {
            $productToolbarMobile.removeClass('semi-opened fully-opened');
            if (app.isProductToolbarMobileOpen) {
              app.isProductToolbarMobileOpen = false;
            }
          }
        }); // add scroll event listener
      }

      // mobile product form - sticky toolbar
      enquire.register('screen and (min-width: 720px)', {
        setup: function setup() {
          registerMobileToolbar();
        },
        match: function match() {
          $productToolbarMobile.hide();

          $imageZoom.zoomio({
            fadeduration: 200
          });
        },
        unmatch: function unmatch() {
          registerMobileToolbar();
        }
      });
      document.cookie = 'current_url=' + app.product.handle + ';expires=' + expirationDate.toGMTString() + ';path=/';

      setTimeout(function () {
        // eslint-disable-next-line eqeqeq
        if (app.mainProduct.product_tags != undefined) {
          var flagNotify = false;
          app.mainProduct.product_tags.forEach(function (tag) {
            app.product.variants.forEach(function (variant) {
              if (tag.indexOf('VariantName_') > -1) {
                // eslint-disable-next-line eqeqeq
                if (app._handleize(variant.title).indexOf(app._handleize(tag.split('VariantName_')[1])) > -1) {
                  flagNotify = true;
                }
              }
            });
          });
          // eslint-disable-next-line eqeqeq
          if (flagNotify == false) {
            $('[data-hide-notify-me]').addClass('d-none').removeClass('d-flex');
            $('[data-notify-me-2]').removeClass('d-none');
          }
        }
      }, 3000);
    },
    _getAllDetails: function _getAllDetails() {
      setTimeout(function () {
        var productMain = app._getCookie('mainMaterial');
        axios.get('/products/' + productMain + '?view=get-main-product.json').then(function (response) {
          app.mainProduct = response.data;
          app.mainProduct.metafields = response.data.metafields;
          app.mainProduct.variantsALL = response.data.variants;
          var variants = [];
          var variantsTitle = '';
          response.data.variants.forEach(function (variant) {
            // eslint-disable-next-line eqeqeq
            if (variantsTitle != '') {
              // eslint-disable-next-line eqeqeq
              if (variantsTitle.indexOf(variant.title.split(' / ')[0]) == -1) {
                if (variant.title.indexOf('1-tone') > -1 || variant.title.indexOf('2-tone') > -1) {
                  variant.title = variant.title.split(' / ')[0];
                  variantsTitle += variant.title;
                }
              }
            } else if (variant.title.indexOf('1-tone') > -1 || variant.title.indexOf('2-tone') > -1) {
              variant.title = variant.title.split(' / ')[0];
              variantsTitle += variant.title;
            }
            variants.push(variant);
          });
          app.mainProduct.variants = variants;
          app.mainProduct.tags = response.data.tags;
          app.mainProduct.product_tags = response.data.tags_array;
          var onlymat = '';var nomat = '';
          app.mainProduct.product_tags.forEach(function (tag) {
            if (tag.indexOf('onlymat') > -1) {
              onlymat = tag.split('_')[1];
            }
            if (tag.indexOf('nomat') > -1) {
              nomat = tag.split('_')[1];
            }
          });

          // eslint-disable-next-line eqeqeq
          if (onlymat != '' && nomat != '') {
            app._getOption(onlymat, nomat);
            // eslint-disable-next-line eqeqeq
          } else if (nomat != '') {
            app._getOption('', nomat);
            // eslint-disable-next-line eqeqeq
          } else if (onlymat != '') {
            app._getOption(onlymat, '');
            // eslint-disable-next-line eqeqeq
          } else {
            app._getOption('', '');
          }
          return response;
        }).catch(function (error) {
          throw error;
        });
        axios.get('/products/' + productMain + '?view=main-product').then(function (response) {
          $('[data-image-div]').css('opacity', '0');
          $('[data-image-div]').html($(response.data).find('[data-image-div]').html());
          $('.product_short_description').html($(response.data).find('.product_short_description').html());
          $('[data-tabify-section]').html($(response.data).find('[data-tabify-section]').html());
          $('[data-videos-modals]').html($(response.data).find('[data-videos-modals]').html());
          $('[data-price]').html($(response.data).find('[data-price]').html());
          // if ($(response.data).find('[data-sku-target]').length > 0) {
          //   $('[data-sku-target]').html($(response.data).find('[data-sku-target]').html());
          // }
          var checkTitle = $.trim($(response.data).find('[data-title]').text());
          if (checkTitle.indexOf('Car') > -1) {
            checkTitle = $.trim(checkTitle.split('Car ')[0]);
          } else if (checkTitle.indexOf('car') > -1) {
            checkTitle = $.trim(checkTitle.split('car ')[0]);
          } else if (checkTitle.indexOf('seat') > -1) {
            checkTitle = $.trim(checkTitle.split('seat ')[0]);
          } else if (checkTitle.indexOf('Seat') > -1) {
            checkTitle = $.trim(checkTitle.split('Seat ')[0]);
          }
          $('[data-title-replace]').text(checkTitle);
          $('.target-model').text(app._getCookie('vehicle_model'));
          $('.target-year').text(app._getCookie('vehicle_year'));
          app._flickityTrigger();
          return response;
        }).catch(function (error) {
          throw error;
        });
      }, 700);
    },
    _redirectDirectlyByHandle: function _redirectDirectlyByHandle(getMain) {
      // Cookies
      var today = new Date();
      var expirationDate = new Date();
      expirationDate.setDate(today.getDate());
      var time = expirationDate.getTime();
      var expireTime = time + 1000 * 36000;
      expirationDate.setTime(expireTime);

      var isCheckProductID = '';
      var isCheckMcat = '';
      var handleAdded = void 0;

      // eslint-disable-next-line eqeqeq
      if (app.product.handle.indexOf('-floor-mats') > -1) {
        isCheckProductID = 'DFM';
        // eslint-disable-next-line eqeqeq
        if (getMain != undefined) {
          handleAdded = getMain;
        } else {
          handleAdded = 'floor-mats-' + app._handleize(app.product.variants[0].title);
        }
        // eslint-disable-next-line eqeqeq
      } else if (app.product.handle.indexOf('-seat-cover') > -1) {
        isCheckProductID = 'CSC';
        // eslint-disable-next-line eqeqeq
        if (getMain != undefined) {
          handleAdded = getMain;
        } else {
          handleAdded = 'seat-cover-' + app._handleize(app.product.variants[25].title);
        }
        // eslint-disable-next-line eqeqeq
      } else if (app.product.handle.indexOf('-car-cover') > -1) {
        isCheckProductID = 'CVC';
        // eslint-disable-next-line eqeqeq
        if (getMain != undefined) {
          handleAdded = getMain;
        } else {
          handleAdded = 'car-cover-' + app._handleize(app.product.variants[0].title);
        }
        // eslint-disable-next-line eqeqeq
      } else if (app.product.handle.indexOf('-dash-cover') > -1) {
        isCheckProductID = 'CDC';
        // eslint-disable-next-line eqeqeq
        if (getMain != undefined) {
          handleAdded = getMain;
        } else if (app.product.variants[8]) {
          handleAdded = 'dash-cover-' + app._handleize(app.product.variants[8].title);
        } else {
          handleAdded = 'dash-cover-' + app._handleize(app.product.variants[0].title);
        }
        // eslint-disable-next-line eqeqeq
      } else if (app.product.handle.indexOf('-rear-deck-cover') > -1) {
        isCheckProductID = 'CRD';
        // eslint-disable-next-line eqeqeq
        if (getMain != undefined) {
          handleAdded = getMain;
        } else {
          handleAdded = 'rear-deck-cover-' + app._handleize(app.product.variants[0].title);
        }
        // eslint-disable-next-line eqeqeq
      } else if (app.product.handle.indexOf('-frost-shield') > -1) {
        isCheckProductID = 'CFS';
        handleAdded = 'frost-shield';
        // eslint-disable-next-line eqeqeq
      } else if (app.product.handle.indexOf('-frost-shield') > -1) {
        isCheckProductID = 'CSS';
        handleAdded = 'custom-sunshield';
      }

      // eslint-disable-next-line eqeqeq
      if (handleAdded != undefined) {
        axios.get('/products/' + handleAdded + '.json')
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          var arraTags = response.data.product.tags.split(',');
          arraTags.forEach(function (tag) {
            if (tag.indexOf('mcat') > -1) {
              isCheckMcat = tag.replace('mcat-', '');
            }
            document.cookie = 'mainMaterial=' + handleAdded + ';expires=' + expirationDate.toGMTString() + ';path=/';
            document.cookie = 'productID=' + isCheckProductID + ';expires=' + expirationDate.toGMTString() + ';path=/';
            document.cookie = 'mcat=' + isCheckMcat + ';expires=' + expirationDate.toGMTString() + ';path=/';
          });
        }).catch(function (error) {
          console.log(error);
          throw error;
        });
      }

      app.product.tags.forEach(function (tag) {
        if (tag.indexOf('year') > -1) {
          app.selectedYear = tag.split('year_')[1];
          document.cookie = 'vehicle_year=' + app.selectedYear + ';expires=' + expirationDate.toGMTString() + ';path=/';
        }
        if (tag.indexOf('make') > -1) {
          if (tag.indexOf('||') > -1) {
            app.selectedMake = tag.replaceAll('||', ',').split('make_')[1];
          } else {
            app.selectedMake = tag.split('make_')[1];
          }
          document.cookie = 'vehicle_make=' + app.selectedMake + ';expires=' + expirationDate.toGMTString() + ';path=/';
        }
        if (tag.indexOf('model') > -1) {
          if (tag.indexOf('||') > -1) {
            app.selectedModel = tag.replaceAll('||', ',').split('model_')[1];
          } else {
            app.selectedModel = tag.split('model_')[1];
          }
          document.cookie = 'vehicle_model=' + app.selectedModel + ';expires=' + expirationDate.toGMTString() + ';path=/';
        }
      });

      app._getSubModel('redirect');

      document.cookie = 'vehicle_details=' + app.selectedYear + ' ' + app.selectedMake + ' ' + app.selectedModel + ';expires=' + expirationDate.toGMTString() + ';path=/';
      document.cookie = 'vehicle_details_display=' + app.selectedYear + ' ' + app.selectedMake + ' ' + app.selectedModel + ' ' + app.selectedSubModel + ';expires=' + expirationDate.toGMTString() + ';path=/';
      app.selectedbaseVehicle = app._getCookie('vehicle_base_vehicle');
      app.cookieSelectedVehicle = app._getCookie('vehicle_details');
      app.cookieSelectedVehicleDisplay = app._getCookie('vehicle_details_display');

      app._getAllDetails();
    },
    _fileUpload: function _fileUpload(productType) {
      if ($('#new_file').length > 0) {
        document.querySelector('#new_file').addEventListener('click', function (event) {
          event.preventDefault();
          var client = filestack.init('AUOhMY2z1SpqsXMHac8U0z');
          var options = {
            maxFiles: 20,
            uploadInBackground: false,
            onOpen: function onOpen() {
              return console.log('opened!');
            },
            onUploadDone: function onUploadDone(res) {
              console.log(res.filesUploaded[0].handle);
              app._uploadByHandle(productType, res.filesUploaded[0].handle);
            }
          };
          client.picker(options).open();
        });
      }
    },
    _uploadByHandle: function _uploadByHandle(type, handle) {
      axios.post('https://cpiapi.coverking.com/api/file-stack/store?handle=' + handle + '&tag=' + type)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        app._getByHandle(type);
      }).catch(function (error) {
        throw error;
      });
    },
    _getByHandle: function _getByHandle(type) {
      axios.get('https://cpiapi.coverking.com/api/file-stack/get-file-stacks?tag=' + type)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        app.allCustomImages = [];
        response.data.File_stacks.forEach(function (handle) {
          app.allCustomImages.push('https://cdn.filestackcontent.com/' + handle);
        });
        // eslint-disable-next-line promise/always-return
        if (response.data.File_stacks.length === 0) {
          $('.section-customer-photos .col-lg-7').addClass('d-none');
        } else {
          $('.section-customer-photos .col-lg-7').removeClass('d-none');
        }
      }).catch(function (error) {
        throw error;
      });
    },


    /**
     * Event when product option select or input changes
     *
     */
    _getVariant: function _getVariant(event) {
      var variant = app._getVariantFromOptions(event);

      // stop parsing if there is no variant info
      if (!variant) {
        app.currentVariant = {};
        return;
      }

      app._checkWishlist(variant);

      // eslint-disable-next-line eqeqeq
      if (app._getCookie('mainMaterial') != 'mainMaterial' && $('[data-simple-product]').length == 0 && app.selectedMaterialID != '') {
        app.itemID = app.currentVariant.sku;
        app._getShipDays('universal', event);
      }

      if ($('[data-simple-product]').length > 0) {
        app._getUniversalInventory(app.currentVariant.sku);
      }

      if (app.isQuickshopModalOpen) {
        app.quickShop.currentVariant = variant;

        // ReCharge Integration for the quick shop
        // Update data needed for ReCharge when variant changes
        // get current variant metafields for subscriptions
        axios.get('/products/' + app.quickShop.product.handle + '?variant=' + variant.id + '&view=variant-metafields-subscriptions.json').then(function (response) {
          if (response.data.discount_variant_id) {
            var rechargeFunction = 'reChargeJS_' + app.quickShop.product.id;
            // assign
            app.quickShop.metafields.subscriptions = response.data;
            app.reChargeDiscountVariantId = response.data.discount_variant_id;
            // Initialize Recharge widget script (currently opened product)
            window[rechargeFunction]($);
          }
          return response;
        }).catch(function (error) {
          throw error;
        });
      } else if (app.currentTemplate === 'collection') {
        // collection
        var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        product.current_variant = variant;
      } else if (app.currentTemplate === 'product') {
        app.currentVariant = variant;
        // eslint-disable-next-line eqeqeq
        if (app.enableHistoryState && window.location.href.indexOf('color=') == -1) {
          app._updateHistoryState(variant);
        }

        // ReCharge Integration for the product page
        // Update data needed for ReCharge when variant changes
        var discountVariantId = $('[data-variant-id="' + variant.id + '"]').attr('data-discount-variant-id');
        app.reChargeDiscountVariantId = discountVariantId;
      }
    },
    _changeImage: function _changeImage(event, title, additional, select) {
      app.isSpinnerVisible = true;
      // eslint-disable-next-line eqeqeq
      if (select == 'select_option') {
        $(event.currentTarget).closest('[data-closest]').find('[data-name-swatch]').text($(event.currentTarget).val());
      } else {
        $(event.currentTarget).closest('[data-closest]').find('[data-name-swatch]').text($(event.currentTarget).data('title'));
      }
      $('[data-submit-form-3]').removeAttr('disabled');

      $('[data-image-div]').css('opacity', '0');
      if ($('.carousel-nav').length > 0) {
        var flkty1 = new Flickity('.carousel-nav'); // init flickity
        flkty1.destroy();
        $('.carousel-nav').removeClass('flickity-enabled').empty();
      }
      var flkty2 = new Flickity('[data-carousel-main]'); // init flickity
      flkty2.destroy();
      $('[data-carousel-main]').removeClass('flickity-enabled is-draggable').empty();

      $('[data-carousel-main]').html('');
      if ($('.carousel-nav').length > 0) {
        $('.carousel-nav').html('');
      }

      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=ship-days&itemId=' + app.currentVariant.sku)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        app.shipDays = response.data.Ship_Days.Business_Days;
      }).catch(function (error) {
        throw error;
      });

      // eslint-disable-next-line shopify/prefer-module-scope-constants
      var main_HTML = '';var nav_HTML = '';
      var main_default_HTML = '';var nav_default_HTML = '';
      // eslint-disable-next-line eqeqeq
      if (additional != '') {
        var images = JSON.parse($('[data-product-' + additional + '-json]').html());
        images.product_images.forEach(function (image) {
          var imageSRC = image.src.split('.jpg')[0];
          var imageSRCNav = imageSRC + '_100x.jpg';
          var imageSRCMain = imageSRC + '_650x600.jpg';
          // eslint-disable-next-line eqeqeq
          if (image.alt == title) {
            main_HTML += '<div class=\'carousel-cell col-12 mb-3 mb-lg-0\' role=\'treeitem\'><img class=\'lazyload img-fluid\' src=\'' + imageSRCMain + '\' alt=\'' + image.alt + '\'></div>';
            nav_HTML += '<div class=\'carousel-cell\'><img src=\'' + imageSRCNav + '\' alt=\'' + image.alt + '\' role=\'treeitem\'></div>';
          }
        });
        app.product.media.forEach(function (image) {
          var imageSRC = image.src.split('.jpg')[0];
          var imageSRCNav = imageSRC + '_100x.jpg';
          var imageSRCMain = imageSRC + '_650x600.jpg';
          // eslint-disable-next-line eqeqeq
          if (image.alt != null) {
            if (image.alt.indexOf('-Default') > -1) {
              main_default_HTML += '<div class=\'carousel-cell col-12 mb-3 mb-lg-0\' role=\'treeitem\'><img class=\'lazyload img-fluid\' src=\'' + imageSRCMain + '\' alt=\'' + image.alt + '\'></div>';
              nav_default_HTML += '<div class=\'carousel-cell\'><img src=\'' + imageSRCNav + '\' alt=\'' + image.alt + '\' role=\'treeitem\'></div>';
            }
          }
        });
      } else {
        app.product.media.forEach(function (image) {
          var imageSRC = image.src.split('.jpg')[0];
          var imageSRCNav = imageSRC + '_100x.jpg';
          var imageSRCMain = imageSRC + '_650x600.jpg';
          // eslint-disable-next-line eqeqeq
          if (image.alt == app.currentVariant.title) {
            main_HTML += '<div class=\'carousel-cell col-12 mb-3 mb-lg-0\' role=\'treeitem\'><img class=\'lazyload img-fluid\' src=\'' + imageSRCMain + '\' alt=\'' + image.alt + '\'></div>';
            nav_HTML += '<div class=\'carousel-cell\'><img src=\'' + imageSRCNav + '\' alt=\'' + image.alt + '\' role=\'treeitem\'></div>';
          }
          // eslint-disable-next-line eqeqeq
          if (image.alt != null) {
            if (image.alt.indexOf('-Default') > -1) {
              main_default_HTML += '<div class=\'carousel-cell col-12 mb-3 mb-lg-0\' role=\'treeitem\'><img class=\'lazyload img-fluid\' src=\'' + imageSRCMain + '\' alt=\'' + image.alt + '\'></div>';
              nav_default_HTML += '<div class=\'carousel-cell\'><img src=\'' + imageSRCNav + '\' alt=\'' + image.alt + '\' role=\'treeitem\'></div>';
            }
          }
        });
      }

      // eslint-disable-next-line eqeqeq
      if (main_HTML != '') {
        $('[data-carousel-main]').html(main_HTML);
        if ($('.carousel-nav').length > 0) {
          $('.carousel-nav').html(nav_HTML);
        }
      } else {
        $('[data-carousel-main]').html(main_default_HTML);
        if ($('.carousel-nav').length > 0) {
          $('.carousel-nav').html(nav_default_HTML);
        }
      }
      app._flickityTrigger();
    },
    _autoSelected: function _autoSelected(color) {
      axios.get('https://cpiapi.coverking.com/api/get-vehicle-details?type=universal-seat-cover&color=' + color).then(function (response) {
        // eslint-disable-next-line eqeqeq
        if (response.data.Seat_Cover_By_Color.Design_name != undefined) {
          app.isSpinnerVisible = true;
          app.getUniversalDesign = response.data.Designs;
          app.selectedUniversalDesign = response.data.Seat_Cover_By_Color.Design_name;
          app.selectedUniversalCategory = response.data.Seat_Cover_By_Color.Category_name;
          app.selectedMaterialNameUltimate = response.data.Seat_Cover_By_Color.Color;
          app._getUniversalSeatCategory();
          app._getUniversalSeatResources();
          setTimeout(function () {
            $('[data-suede-1]').val(response.data.Seat_Cover_By_Color.Design_name);
            $('[data-suede-2]').val(app.selectedUniversalCategory);
            $('[data-description="' + response.data.Seat_Cover_By_Color.Color + '"]').attr('checked', 'checked').trigger('change');
            var swatch = $('[data-description="' + response.data.Seat_Cover_By_Color.Color + '"]').attr('id');
            var img = $('[data-description="' + response.data.Seat_Cover_By_Color.Color + '"]').attr('data-img');
            app.isSpinnerVisible = false;
            // app._swatchChange(event, swatch, 'ultimate-suede', img, '');
            setTimeout(function () {
              if (response.data.color_swatch_id == null) {
                $('[data-swatches-description] .color-swatch:first label').trigger('click');
              } else {
                $('[data-swatches-description] .color-swatch [for="' + response.data.color_swatch_id + '"]').trigger('click');
              }
            }, 1000);
          }, 1600);
        }
        return response.data;
      }).catch(function (error) {
        app.isLoading = false;
        app.loadingEvent = null;
        app._snotifyMsg('Error', 'Something might be wrong.', 'Error');
        throw error;
      });
    },
    _swatchChange: function _swatchChange(event, swatch, type, newImage, description) {
      // eslint-disable-next-line eqeqeq
      if (type == '') {
        $(event.currentTarget).closest('[data-check-input]').find('[data-name-swatch]').text(swatch);
        app.selectedMaterialID = $(event.currentTarget).val().replace('material-', '');
        var dataText = $(event.currentTarget).closest('[data-seat-template]').find('[data-title]').text();
        var shipIDPass = '' + app._getCookie('productID') + app.selectedMaterialID;
        if (app.product.handle.indexOf('floor-mats') > -1) {
          // eslint-disable-next-line eqeqeq
          if ($.trim(dataText) == 'Front') {
            shipIDPass = app._getCookie('productID') + 'A' + app.selectedMaterialID;
            // eslint-disable-next-line eqeqeq
          } else if ($.trim(dataText) == 'Front Center') {
            shipIDPass = app._getCookie('productID') + 'B' + app.selectedMaterialID;
          } else {
            shipIDPass = app._getCookie('productID') + 'C' + app.selectedMaterialID;
          }
        }
        $(event.currentTarget).closest('[data-seat-template]').attr('data-material', shipIDPass);
        $(event.currentTarget).closest('[data-seat-template]').attr('data-materialID', app.selectedMaterialID);
        var matchMaterial = 'material-' + $(event.currentTarget).val();
        app.selectedMaterialName = swatch;
        $.each(app.mainProduct.metafields, function (key, value) {
          var colors = void 0;
          if (value[0].length > 2) {
            colors = value;
          } else {
            colors = JSON.parse(value);
          }
          // eslint-disable-next-line eqeqeq
          if (key == matchMaterial) {
            $('[data-image-div]').css('opacity', '0');
            if ($('.carousel-nav').length > 0) {
              var flkty1 = new Flickity('.carousel-nav'); // init flickity
              flkty1.destroy();
              $('.carousel-nav').removeClass('flickity-enabled').empty();
            }
            var flkty2 = new Flickity('[data-carousel-main]'); // init flickity
            flkty2.destroy();
            $('[data-carousel-main]').removeClass('flickity-enabled is-draggable').empty();

            $('[data-carousel-main]').html('');
            if ($('.carousel-nav').length > 0) {
              $('.carousel-nav').html('');
            }
            app.isSpinnerVisible = true;
            var htmlMain = '';var htmlNav = '';
            $.each(colors, function (key, value) {
              var imageSRC = value.split('.jpg')[0];
              var imageSRCNav = imageSRC + '_100x.jpg';
              var imageSRCMain = imageSRC + '_650x600.jpg';
              htmlMain += '<div class="carousel-cell col-12 mb-3 mb-lg-0" role="treeitem"><img class="img-fluid" data-sizes="auto" src="' + imageSRCMain + '"/></div>';
              htmlNav += '<div class="carousel-cell"><img src="' + imageSRCNav + '" role="treeitem"></div>';
            });
            $('[data-carousel-main]').html(htmlMain);
            if ($('.carousel-nav').length > 0) {
              $('.carousel-nav').html(htmlNav);
            }
            app._flickityTrigger();
          }
        });
        // if (app.getOptionJson.Option_Generated.length > 0 && app.getOptionJson.Material_Category_Img_Lists.Swatches.length > 0) {
        //   // eslint-disable-next-line eqeqeq
        //   if (app.selectedMaterialID != '' && app.selectedRecID != '') {
        //     app._getCartPrice();
        //   }
        // // eslint-disable-next-line eqeqeq
        // } else if (app.selectedMaterialID != '') {
        //   app._getCartPrice();
        // }
        // eslint-disable-next-line eqeqeq
        if (app.selectedRecID != '' || app.selectedUniversalDesign != '' || app.selectedUniversalCategory != '') {
          app._getCartPrice(event);
        }
      } else {
        app.selectedMaterialNameUltimate = swatch;
        $('[data-description-add]').text(description);
        // eslint-disable-next-line promise/catch-or-return
        axios.get('/collections/ultimate-suede-collection/optionID_' + app.selectedMaterialNameUltimate + '?view=products.json')
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          // eslint-disable-next-line promise/always-return
          if (response.data.products.length > 0) {
            app.currentVariant = response.data.products[0].product.variants[0];
            $('[data-ultimate-seat-suede]').removeAttr('disabled');
            $('[data-price] .actual-price').text(app._formatMoney(app.currentVariant.price));
            $('[data-error-suede]').addClass('d-none');
          } else {
            app._snotifyMsg('Error', 'Product is currently not available.', 'Error');
            $('[data-error-suede]').removeClass('d-none');
            $('[data-ultimate-seat-suede]').attr('disabled', 'disabled');
          }
        });
        app.isSpinnerVisible = true;
        $('[data-image-div]').css('opacity', '0');
        if ($('.carousel-nav').length > 0) {
          var flkty1 = new Flickity('.carousel-nav'); // init flickity
          flkty1.destroy();
          $('.carousel-nav').removeClass('flickity-enabled').empty();
        }
        var flkty2 = new Flickity('[data-carousel-main]'); // init flickity
        flkty2.destroy();
        $('[data-carousel-main]').removeClass('flickity-enabled is-draggable').empty();

        $('[data-carousel-main]').html('');
        if ($('.carousel-nav').length > 0) {
          $('.carousel-nav').html('');
        }
        var htmlMain = '';var htmlNav = '';
        // eslint-disable-next-line eqeqeq
        if (newImage != '') {
          htmlMain = '<div class="carousel-cell col-12 mb-3 mb-lg-0" role="treeitem"><img class="img-fluid" data-sizes="auto" src="' + newImage + '"/></div>';
          htmlNav = '<div class="carousel-cell"><img src="' + newImage + '" role="treeitem"></div>';
        }
        app.product.media.forEach(function (image) {
          var imageSRC = image.src.split('.jpg')[0];
          var imageSRCNav = imageSRC + '_100x.jpg';
          var imageSRCMain = imageSRC + '_650x600.jpg';
          htmlMain += '<div class="carousel-cell col-12 mb-3 mb-lg-0" role="treeitem"><img class="img-fluid" data-sizes="auto" src="' + imageSRCMain + '"/></div>';
          htmlNav += '<div class="carousel-cell"><img src="' + imageSRCNav + '" role="treeitem"></div>';
        });
        $('[data-carousel-main]').html(htmlMain);
        if ($('.carousel-nav').length > 0) {
          $('.carousel-nav').html(htmlNav);
        }
        app._flickityTrigger();
      }
    },
    _flickityTrigger: function _flickityTrigger() {
      setTimeout(function () {
        $('[data-image-div]').css('opacity', '1');
        if ($('.carousel-nav').length > 0) {
          var flkty3 = new Flickity('.carousel-nav', {
            asNavFor: '.carousel-main',
            draggable: false,
            contain: true,
            percentPosition: false,
            cellAlign: 'left',
            groupCells: false,
            pageDots: false
          });
        }
        var flkty4 = new Flickity('[data-carousel-main]', {
          contain: true,
          wrapAround: false,
          freeScroll: false,
          accessibility: true,
          setGallerySize: true,
          prevNextButtons: true,
          pageDots: true,
          lazyLoad: true,
          fullscreen: true,
          dragThreshold: 20
        });
        app.isSpinnerVisible = false;
      }, 800);
    },


    /**
     * Get the currently selected options from add-to-cart form.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions(event) {
      var singleOptionSelector = app.selectors.singleOptionSelector;
      var currentOptions = [];
      var $container = void 0;

      if (app.isQuickshopModalOpen) {
        $container = $('[data-template="quickshop"]').find(app.selectors.productForm);
      } else {
        $container = event ? $(event.currentTarget).closest(app.selectors.productForm) : $(app.selectors.productForm);
      }

      $.map($(singleOptionSelector, $container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            currentOptions.push(currentOption);
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          currentOptions.push(currentOption);
        }
      });

      return currentOptions;
    },


    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions(event) {
      var selectedValues = app._getCurrentOptions(event);
      var variants = void 0;
      var found = false;

      if (app.isQuickshopModalOpen) {
        // quickshop
        variants = app.quickShop.product.variants;
      } else if (app.currentTemplate === 'collection') {
        // collection
        var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        variants = product.variants;
      } else if (app.currentTemplate === 'product') {
        // product
        variants = app.product.variants;
      }

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },


    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newUrl = void 0;

      var showReviewForm = app._getUrlParameter('showReviewForm');

      if (showReviewForm === '') {
        // eslint-disable-next-line eqeqeq
        if (jQuery.inArray('main_material', app.product.tags) == -1) {
          newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id + '&sub=' + app._getCookie('vehicle_submodel') + '&main=' + app._getCookie('mainMaterial');
        } else {
          newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        }
      } else {
        newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id + '&showReviewForm=' + showReviewForm;
      }

      window.history.replaceState({
        path: newUrl
      }, '', newUrl);
    },


    /**
     * Find variant image and scroll to this image
     * works for all product page templates
     * can be extended to update all images upon variant selection
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateImages: function _updateImages(variant, event) {
      var variantImage = variant.featured_image || {};
      var variantTitle = variant.title;
      var templateType = $('[data-product-template]').data('product-template');
      var $scrollTarget = $('[data-variant-title="' + variantTitle + '"]');
      var $container = void 0;
      var currentVariantImage = void 0;

      if (app.isQuickshopModalOpen) {
        $container = $('[data-template="quickshop"]');
        currentVariantImage = app.quickShop.currentVariant.featured_image || {};
      } else if (app.currentTemplate === 'collection') {
        $container = $(event.currentTarget).closest(app.selectors.productForm);
        var productId = $container.data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        if (product.current_variant.featured_image) {
          currentVariantImage = product.current_variant.featured_image.src || {};
        } else {
          currentVariantImage = product.featured_image || {};
        }
      } else if (app.currentTemplate === 'product') {
        $container = $('[data-template="product"]');
        currentVariantImage = app.currentVariant.featured_image || {};
      }

      var $carousel = $container.find('[data-carousel-main]');

      if (variantImage.src === currentVariantImage.src) {
        return;
      }

      enquire.register('screen and (min-width: 720px)', {
        match: function match() {
          // For the 'minimal' product template
          // Scroll to variant image unless it's the first photo on load
          if (templateType === 'minimal' && !app.isQuickshopModalOpen && $scrollTarget[0]) {
            $('html, body').animate({
              scrollTop: $scrollTarget.offset().top
            }, 350);
          }
        }
      });

      if ($carousel.length > 0) {
        var flkty = Flickity.data($carousel[0]);

        if (typeof flkty === 'undefined') {
          return;
        }

        var cellElements = flkty.getCellElements();
        cellElements.forEach(function (element, index) {
          var imgAlt = $(element).data('variant-title');
          if (variantTitle.indexOf(imgAlt) !== -1) {
            flkty.selectCell(index, true, false); // value, isWrapped, isInstant
          }
        });
      }
    },


    /**
     * Mobile toolbar - product form - options
     */
    _toggleProductToolbarMobile: function _toggleProductToolbarMobile() {
      var $productToolbarMobile = $(app.selectors.productToolbarMobile);
      app.isProductToolbarMobileOpen = !app.isProductToolbarMobileOpen;
      $productToolbarMobile.toggleClass('fully-opened');
    }
  }
};

export default productMethods;